"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// assets
//
const noTrackingPages_png_1 = __importDefault(require("../../../../assets/images/dashboard/noTrackingPages.png"));
const trackingCopy_1 = require("../../../../copy/trackingCopy");
//
// components
//
const TrackingPageCard_1 = __importDefault(require("../TrackingPageCard"));
const LoadingSpinner_1 = __importDefault(require("../../../general/LoadingSpinner"));
//
// styles
//
const StyledListContainer_1 = require("../StyledListContainer");
const StyledErrorText_1 = require("../../StyledErrorText");
const StyledGraphic_1 = require("../../StyledGraphic");
const StyledGreyText_1 = require("../../StyledGreyText");
const StyledHeader_1 = require("../../StyledHeader");
const StyledMediumText_1 = require("../../StyledMediumText");
const StyledMessageContainer_1 = require("../../StyledMessageContainer");
const ArchivedPages = (props) => {
    const { trackingPages, error, loading } = props;
    function displayError(apiError) {
        if (apiError.message.includes('ECONNREFUSED') ||
            apiError.message.toLowerCase().includes('failed')) {
            return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, trackingCopy_1.trackingCopy.fetchError));
        }
        return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, apiError.message));
    }
    function renderLoading() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(LoadingSpinner_1.default, null),
            react_1.default.createElement(StyledMediumText_1.StyledMediumText, { className: 'loading', role: 'paragraph' }, trackingCopy_1.trackingCopy.loading)));
    }
    function renderNoTrackingPages() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, { height: '370px' },
            react_1.default.createElement(StyledGraphic_1.StyledGraphic, { src: noTrackingPages_png_1.default }),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, trackingCopy_1.trackingCopy.noArchivedTrackingPagesHeader),
            react_1.default.createElement(StyledGreyText_1.StyledGreyText, { className: 'no-pages', role: 'paragraph' }, trackingCopy_1.trackingCopy.noArchivedTrackingPagesParagraph)));
    }
    function renderPages() {
        return (react_1.default.createElement(StyledListContainer_1.StyledListContainer, null, trackingPages.map((item) => (react_1.default.createElement(TrackingPageCard_1.default, { active: false, created: item.insertedAt, key: item.id, onDelete: () => props.onDeletePage(item), onRestore: () => props.onRestorePage(item), title: item.name, updated: item.archivedAt, url: [item.hostedDomain.token, item.slug].join('/') })))));
    }
    if (error) {
        return react_1.default.createElement("div", null, displayError(error));
    }
    if (loading) {
        return renderLoading();
    }
    if (!trackingPages || trackingPages.length === 0) {
        return renderNoTrackingPages();
    }
    return renderPages();
};
ArchivedPages.propTypes = {
    error: prop_types_1.default.bool,
    loading: prop_types_1.default.bool,
    newAccount: prop_types_1.default.string,
    onDeletePage: prop_types_1.default.func,
    onEditPage: prop_types_1.default.func,
    onRestorePage: prop_types_1.default.func,
    trackingPages: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        node: prop_types_1.default.shape({
            id: prop_types_1.default.string,
            insertedAt: prop_types_1.default.string
        })
    }))
};
exports.default = ArchivedPages;
